import Link from '@/components/Link';

export default function CertificationDetailsLink({ url }) {
  return (
    <Link
      href={url}
      className="focus:bg-gra-900 flex w-full items-center justify-center space-x-2 rounded-full border border-transparent bg-gray-900 px-4 py-2 text-center font-semibold leading-5 text-white ring-transparent hover:bg-gray-800 focus:outline-none focus:ring-4 focus:ring-gray-600 focus:ring-opacity-20 lg:text-lg"
    >
      Más información
    </Link>
  );
}
